import { render, staticRenderFns } from "./CountryList.vue?vue&type=template&id=0c772c3a&scoped=true&"
import script from "./CountryList.vue?vue&type=script&lang=ts&"
export * from "./CountryList.vue?vue&type=script&lang=ts&"
import style0 from "./CountryList.vue?vue&type=style&index=0&id=0c772c3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c772c3a",
  null
  
)

export default component.exports